export function overrideMethodWithFormmethod(_ref) {
  var _ref$detail$formSubmi = _ref.detail.formSubmission,
      fetchRequest = _ref$detail$formSubmi.fetchRequest,
      submitter = _ref$detail$formSubmi.submitter;

  if (submitter && submitter.formMethod && fetchRequest.body.has("_method")) {
    fetchRequest.body.set("_method", submitter.formMethod);
  }
}